export const prodConfigs = {
    serverUrl: process.env.REACT_APP_SERVER,
    fileServer: process.env.REACT_APP_FILE_SERVER,
    filePath: process.env.REACT_APP_FILE_PATH
}